// kiosk_response_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const responseData = JSON.parse(this.element.dataset.response)
    console.log(responseData)
  }
}
